
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddOrRemoveDocumentToMeetingDtoFormGroup() {
return new FormGroup({
    documentId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      